import { rem } from "polished";
import styled from "styled-components";

export const VideoWrapper = styled.div`
  margin: 0 auto;

  .text-primitive {
    text-align: center;
  }

  iframe {
    border-radius: ${rem(20)};
  }
`;
